interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}

const SITE_ORIGIN = "https://balha.cn";

export default function PageMeta({
  title,
  description,
  keywords,
  path,
  ogType = "website",
  schema,
}: PageMetaProps) {
  const canonical = `${SITE_ORIGIN}${path}`;
  const ogImage =
    "https://readdy.ai/api/search-image?query=Minimal%20editorial%20banner%20of%20layered%20paper%20documents%20and%20a%20thin%20timeline%20thread%2C%20warm%20rust%20and%20olive%20tones%2C%20cream%20paper%20background%2C%20flat%20clean%20composition&width=1200&height=630&seq=qz-og-cover&orientation=landscape";

  const schemas = schema
    ? Array.isArray(schema)
      ? schema
      : [schema]
    : [];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta name="last-modified" content="2026-05-20" />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="511 求证档案" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="zh_CN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((item, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </>
  );
}